import DOMPurify from "dompurify";

export function decodeHtmlEntities(input?: string | null): string {
  if (!input) return "";

  const textarea = document.createElement("textarea");
  textarea.innerHTML = input;
  return textarea.value;
}

export function toSafeHtml(input?: string | null): { __html: string } {
  const decoded = decodeHtmlEntities(input);

  return {
    __html: DOMPurify.sanitize(decoded, {
      USE_PROFILES: { html: true },
    }),
  };
}

